module.exports = __webpack_public_path__ + "fonts/font.986e435.woff2";